export function isSupportOrAdminUser(role) {
  if (!role) return false;
  return ['support', 'admin'].includes(role);
}
